import { RecommendationInterface } from 'app/recommendation/models/recommendation.model';

import { RecommendationTemplateInterface } from '../models';
import { AssessmentQuestionDataInterface } from '../models/assessment-question-data.model';
import { RecommendationCategoryInterface } from '../models/recommendation-category.model';

export interface RecommendationStateInterface {
  ids?: number[];
  recommendations?: { [id: number ]: RecommendationInterface };
  selectedRecommendation?: number;
  recommendationLibrary?: RecommendationCategoryInterface[];
  selectedLibraryItem?: RecommendationTemplateInterface;
  assessmentQuestionData: AssessmentQuestionDataInterface;
}

export class RecommendationState implements RecommendationStateInterface {
  public ids?: number[];
  public recommendations?: { [id: number ]: RecommendationInterface };
  public selectedRecommendation?: number | null;
  public recommendationLibrary?: RecommendationCategoryInterface[];
  public selectedLibraryItem?: RecommendationTemplateInterface;
  public assessmentQuestionData: AssessmentQuestionDataInterface;

  constructor({
    ids = undefined,
    recommendations = undefined,
    selectedRecommendation = undefined,
    recommendationLibrary = undefined,
    selectedLibraryItem = undefined,
    assessmentQuestionData = undefined,
    }: RecommendationStateInterface) {
    this.ids = ids;
    this.recommendations = recommendations;
    this.selectedRecommendation = selectedRecommendation;
    this.recommendationLibrary = recommendationLibrary;
    this.selectedLibraryItem = selectedLibraryItem;
    this.assessmentQuestionData = assessmentQuestionData;
  }
}
